import { render, staticRenderFns } from "./cModalConsultorios.vue?vue&type=template&id=37134056&scoped=true"
import script from "./cModalConsultorios.vue?vue&type=script&lang=js"
export * from "./cModalConsultorios.vue?vue&type=script&lang=js"
import style0 from "./cModalConsultorios.vue?vue&type=style&index=0&id=37134056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37134056",
  null
  
)

export default component.exports